// extracted by mini-css-extract-plugin
module.exports = {"seriesVideo":"style_seriesVideo__TA5uX"};